module.exports = __webpack_public_path__ + "img/surprise.215c6234.png";